import { render, staticRenderFns } from "./newMaterialPlan.vue?vue&type=template&id=2bd1a984"
import script from "./newMaterialPlan.vue?vue&type=script&lang=js"
export * from "./newMaterialPlan.vue?vue&type=script&lang=js"
import style0 from "./newMaterialPlan.vue?vue&type=style&index=0&id=2bd1a984&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports